import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const Section = ({ title, children }) => (
  <div className="mb-14">
    <h2 className="font-serif text-2xl md:text-3xl text-gold mb-5">{title}</h2>
    <div className="space-y-3 text-[#C7CAD1] leading-relaxed text-[15px]">{children}</div>
  </div>
);

export default function LegalPage() {
  return (
    <div className="min-h-screen bg-ink text-[#F3F4F6] font-body">
      <header className="border-b border-white/10">
        <div className="max-w-3xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
          <span className="font-serif text-lg">Le 30 <span className="text-gold italic">du mois</span></span>
          <Link to="/" data-testid="legal-back" className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.12em] text-[#A0B2CE] hover:text-gold transition-colors">
            <ArrowLeft className="w-4 h-4" /> Accueil
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 md:px-10 py-16">
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-gold mb-6">/ Informations légales</p>
        <h1 className="font-serif text-4xl md:text-5xl mb-16">Mentions légales & confidentialité</h1>

        <Section title="Mentions légales">
          <div className="flex flex-col md:flex-row md:items-start gap-10">
            <div className="flex-1 space-y-3">
              <p><strong className="text-white">Éditeur du site Internet</strong></p>
              <p>Dénomination sociale : LE 30E DU MOIS</p>
              <p>Statut : Association déclarée</p>
              <p>N° Siret : 828 739 177 00016 — APE : 9001Z</p>
              <p>N° RNA : W294007008</p>
              <p>Siège social : 12, rue de Belle Ile en Mer, 29000 QUIMPER</p>
              <p>Adresse électronique : <a href="mailto:le30@le30dumois.fr" className="text-gold hover:underline">le30@le30dumois.fr</a></p>
              <p>Représentant légal : Jean-Sébastien Mével, Président</p>
              <p>Directeur de la publication : Jean-Sébastien Mével, Président</p>
              <div className="text-[#A0B2CE] text-sm space-y-1 pt-2 border-t border-white/10">
                <p><strong className="text-white">Hébergeur du site</strong></p>
                <p>Emergent Labs Inc.</p>
                <p>255 California Street, Suite 550, San Francisco, CA 94111, États-Unis</p>
                <p>Site : <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline">emergent.sh</a> — Contact : <a href="mailto:support@emergent.sh" className="text-gold hover:underline">support@emergent.sh</a></p>
              </div>
            </div>
            <img
              src={`${API}/api/public/legal-visual`}
              alt="Le 30 du mois"
              data-testid="legal-visual"
              className="w-40 md:w-48 shrink-0 rounded-lg border border-white/10 self-start"
            />
          </div>
        </Section>

        <Section title="Article 1 — Préambule">
          <p>La présente politique de confidentialité a pour but d'informer les utilisateurs du site sur la manière dont sont collectées leurs données personnelles, sur les droits dont ils disposent concernant ces données, sur la personne responsable du traitement, sur les destinataires de ces données et sur la politique du site en matière de cookies.</p>
          <p>Sont considérées comme données personnelles toute information permettant d'identifier un utilisateur : noms et prénoms, âge, adresse postale ou email, localisation ou adresse IP (liste non exhaustive).</p>
          <p>Cookies : ce site n'utilise aucun cookie, ni traceur, ni mesure d'audience — aucun bandeau de consentement n'est donc nécessaire à la navigation.</p>
        </Section>

        <Section title="Article 2 — Principes de collecte et de traitement">
          <p>Conformément à l'article 5 du Règlement européen 2016/679 (RGPD), les données à caractère personnel sont traitées de manière licite, loyale et transparente ; collectées pour des finalités déterminées, explicites et légitimes ; adéquates, pertinentes et limitées au nécessaire ; exactes et tenues à jour ; conservées pour une durée n'excédant pas celle nécessaire ; et traitées de façon à garantir une sécurité appropriée.</p>
        </Section>

        <Section title="Article 3 — Données collectées et traitées">
          <p>Les données collectées dans le cadre de notre activité concernent : la gestion de la paye et/ou des notes d'auteurs ; la gestion des informations sociales, fiscales et administratives et le suivi des paiements ; la gestion des salariés (DUE, contrats et attestations).</p>
          <p>Finalités : gestion de la paye et/ou des notes d'auteurs, comptabilité, dossiers de subventions, contrats de cession, de coréalisation ou de coproduction.</p>
          <p>Les données sont conservées dans des conditions raisonnables de sécurité. Aucune donnée n'est transmise à des tiers.</p>
          <p>Hébergement des données : le site et les données qu'il contient sont hébergés par Emergent Labs Inc., 255 California Street, Suite 550, San Francisco, CA 94111 (États-Unis). Ce transfert de données hors Union européenne est encadré par les clauses contractuelles types adoptées par la Commission européenne.</p>
        </Section>

        <Section title="Article 4 — Responsable du traitement">
          <p>Les données à caractère personnel sont collectées par l'Association LE TRENTIEME DU MOIS, dont le siège social est 12, rue de Belle Ile en Mer, 29000 QUIMPER (Siret : 828 739 177 000126 — APE : 9001Z).</p>
          <p>Contact : par courrier au 12, rue de Belle Ile en Mer, 29000 QUIMPER ; par téléphone au 06 46 85 42 84 ; par mail à <a href="mailto:le30@le30dumois.fr" className="text-gold hover:underline">le30@le30dumois.fr</a>.</p>
          <p>Délégué à la protection des données : Jean-Sébastien Mével.</p>
        </Section>

        <Section title="Article 5 — Vos droits">
          <p>En application du RGPD et de la Loi Informatique et Libertés (n° 78-17 du 6 janvier 1978), tout utilisateur dispose des droits suivants : droit d'accès, de rectification et d'effacement ; droit à la portabilité ; droit à la limitation et à l'opposition ; droit de ne pas faire l'objet d'une décision automatisée ; droit de déterminer le sort des données après la mort ; droit de saisir l'autorité de contrôle (CNIL).</p>
          <p>Pour exercer vos droits : LE 30 DU MOIS — 12, rue de Belle Ile en Mer, 29000 QUIMPER, ou par mail à <a href="mailto:le30@le30dumois.fr" className="text-gold hover:underline">le30@le30dumois.fr</a>. Plus d'informations sur <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline">cnil.fr</a>.</p>
        </Section>

        <Section title="Article 6 — Modification de la politique">
          <p>L'éditeur se réserve le droit de modifier la présente politique à tout moment afin d'assurer sa conformité avec le droit en vigueur. L'utilisateur est invité à en prendre connaissance régulièrement. Politique éditée le 24 avril 2024, mise à jour le 27 octobre 2026.</p>
        </Section>
      </main>

      <footer className="border-t border-white/10 py-10 text-center">
        <p className="font-mono text-xs text-[#A0B2CE]">© {new Date().getFullYear()} Le 30 du mois</p>
      </footer>
    </div>
  );
}
